import React, { useEffect, useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Bell, UserPlus, AlertTriangle, Calendar, Sparkles, Clock, CheckCheck } from "lucide-react";
import { timeAgo } from "@/lib/format";
import api from "@/lib/api";

const ICONS = { lead_assigned: UserPlus, deal_risk: AlertTriangle, meeting: Calendar, ai_approval: Sparkles, task_overdue: Clock };
const TINTS = { lead_assigned: "text-blue-600 bg-blue-50", deal_risk: "text-red-600 bg-red-50", meeting: "text-violet-600 bg-violet-50", ai_approval: "text-fuchsia-600 bg-fuchsia-50", task_overdue: "text-amber-600 bg-amber-50" };

export const NotificationsPanel = ({ open, setOpen, onChange }) => {
  const [items, setItems] = useState([]);
  const load = async () => { try { const { data } = await api.get("/notifications"); setItems(data.items || []); onChange?.(data.unread); } catch {} };
  useEffect(() => { if (open) load(); /* eslint-disable-next-line */ }, [open]);
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="right" className="w-full sm:max-w-[400px] p-0">
        <SheetHeader className="px-4 h-16 flex-row items-center justify-between border-b border-slate-200 space-y-0">
          <SheetTitle className="flex items-center gap-2 text-base"><Bell className="h-4 w-4" />Notifications</SheetTitle>
          <Button variant="ghost" size="sm" onClick={markAll} className="text-xs text-slate-500"><CheckCheck className="h-3.5 w-3.5 mr-1" />Mark all read</Button>
        </SheetHeader>
        <div className="overflow-y-auto p-3 space-y-2">
          {items.length === 0 && <div className="text-center text-sm text-slate-400 py-10">You're all caught up.</div>}
          {items.map((n) => {
            const Icon = ICONS[n.kind] || Bell;
            return (
              <div key={n.id} className={`flex gap-3 rounded-xl border p-3 ${n.read ? "border-slate-100 bg-white" : "border-slate-200 bg-slate-50"}`}>
                <div className={`h-9 w-9 rounded-lg flex items-center justify-center shrink-0 ${TINTS[n.kind] || "text-slate-600 bg-slate-100"}`}><Icon className="h-4 w-4" /></div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-slate-900">{n.title}</div>
                  <div className="text-xs text-slate-500 mt-0.5">{n.body}</div>
                  <div className="text-[11px] text-slate-400 mt-1">{timeAgo(n.created_at)}</div>
                </div>
                {!n.read && <span className="h-2 w-2 rounded-full bg-[#7C3AED] shrink-0 mt-1.5" />}
              </div>
            );
          })}
        </div>
      </SheetContent>
    </Sheet>
  );
};
